"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckInPeriodTypeValues = exports.CheckInPeriodType = void 0;
var CheckInPeriodType;
(function (CheckInPeriodType) {
    CheckInPeriodType["CRON"] = "CRON";
    CheckInPeriodType["SIMPLE"] = "SIMPLE";
})(CheckInPeriodType = exports.CheckInPeriodType || (exports.CheckInPeriodType = {}));
exports.CheckInPeriodTypeValues = Object.values(CheckInPeriodType);
